import React, { useState, useEffect } from "react";
import Calendar from "./Calendar";
import TeamCalendar from "./TeamCalendar";
import Login from "./Login";

function App() {
    const [view, setView] = useState("dashboard"); // dashboard or team
    const [theme, setTheme] = useState("dark");
    const [currentUser, setCurrentUser] = useState(null);
    const [isAppReady, setIsAppReady] = useState(false);

    // Initialize theme and check login status
    useEffect(() => {
        const savedTheme = localStorage.getItem("rotation-theme") || "dark";
        setTheme(savedTheme);
        document.documentElement.setAttribute('data-theme', savedTheme);

        const savedUser = localStorage.getItem("rotation-user");
        if (savedUser) {
            setCurrentUser(JSON.parse(savedUser));
        }
        setIsAppReady(true);
    }, []);

    const handleLoginSuccess = (loginData) => {
        setCurrentUser(loginData.user);
        localStorage.setItem("rotation-user", JSON.stringify(loginData.user));
        localStorage.setItem("rotation-token", loginData.token);
    };

    const handleLogout = () => {
        setCurrentUser(null);
        localStorage.removeItem("rotation-user");
        localStorage.removeItem("rotation-token");
    };

    const toggleTheme = () => {
        const newTheme = theme === "dark" ? "light" : "dark";
        setTheme(newTheme);
        localStorage.setItem("rotation-theme", newTheme);
        document.documentElement.setAttribute('data-theme', newTheme);
    };

    if (!isAppReady) return null;

    if (!currentUser) {
        return <Login onLogin={handleLoginSuccess} theme={theme} toggleTheme={toggleTheme} />;
    }

    return (
        <div className="app-container">
            <header className="top-nav">
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <h1 style={{ fontSize: "18px", fontWeight: 700, margin: 0, color: "var(--text-main)" }}>
                        🔄 Rotasiya Platforması
                    </h1>
                    <span style={{
                        fontSize: "11px",
                        color: "var(--text-muted)",
                        backgroundColor: "var(--inactive-btn-bg)",
                        border: "1px solid var(--border-color)",
                        padding: "2px 8px",
                        borderRadius: "12px"
                    }}>
                        v1.2 ERP Integrated
                    </span>
                </div>

                <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                    <nav style={{ display: "flex", gap: "8px" }}>
                        <button
                            className={`btn ${view === "dashboard" ? "active" : ""}`}
                            onClick={() => setView("dashboard")}
                        >
                            <span style={{ fontSize: "16px" }}>📈</span> İşçi Analitikası
                        </button>
                        <button
                            className={`btn ${view === "team" ? "active" : ""}`}
                            onClick={() => setView("team")}
                        >
                            <span style={{ fontSize: "16px" }}>🗓️</span> Komanda Paneli
                        </button>
                    </nav>

                    {/* Divider */}
                    <div style={{ width: "1px", height: "24px", backgroundColor: "var(--border-color)" }}></div>

                    {/* Theme Toggle Switch */}
                    <div
                        onClick={toggleTheme}
                        style={{
                            width: "58px", height: "30px", borderRadius: "20px",
                            backgroundColor: theme === "dark" ? "var(--primary-color)" : "#e2e8f0",
                            position: "relative", cursor: "pointer", display: "flex", alignItems: "center",
                            padding: "0 4px", justifyContent: "space-between",
                            transition: "background-color 0.4s ease",
                            boxShadow: theme === "dark" ? "inset 0 2px 4px rgba(0,0,0,0.3)" : "inset 0 2px 4px rgba(0,0,0,0.05)"
                        }}
                        title={`Sistemin Rejimi: ${theme === 'dark' ? 'Qaranlıq' : 'Aydınlıq'}`}
                    >
                        <span style={{ fontSize: "14px", zIndex: 1, paddingLeft: "3px", textShadow: "0 1px 2px rgba(0,0,0,0.1)", filter: theme === "dark" ? "grayscale(100%) opacity(0.3)" : "none", transition: "all 0.4s ease" }}>☀️</span>
                        <div style={{
                            position: "absolute", width: "24px", height: "24px",
                            backgroundColor: "#fff", borderRadius: "50%",
                            left: theme === "dark" ? "30px" : "4px",
                            transition: "left 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                            zIndex: 2
                        }} />
                        <span style={{ fontSize: "12px", zIndex: 1, paddingRight: "5px", filter: theme === "dark" ? "none" : "grayscale(100%) opacity(0.3)", transition: "all 0.4s ease" }}>🌙</span>
                    </div>

                    {/* Divider */}
                    <div style={{ width: "1px", height: "24px", backgroundColor: "var(--border-color)" }}></div>

                    {/* Logout Button */}
                    <button
                        onClick={handleLogout}
                        className="btn"
                        style={{ padding: "8px 12px", backgroundColor: "var(--danger-bg)", color: "var(--danger-text)", borderColor: "var(--danger-border)" }}
                    >
                        Çıxış ⏻
                    </button>
                </div>
            </header>

            <main style={{ flex: 1, paddingBottom: "40px" }} className="animate-fade-in">
                {view === "dashboard" ? <Calendar /> : <TeamCalendar />}
            </main>
        </div>
    );
}

export default App;
